import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

const PORT = import.meta.env.VITE_COOK_PORT;
const MASTERURL = import.meta.env.VITE_API_COOK_URL;

interface FoodMenuItemApproval {
  id: number;
  foodMenuItemId: number;
  submittedBy: number;
  reviewedBy: number | null;
  approvalStatusId: number;
  approvalComment: string | null;
  submittedAt: string;
  reviewedAt: string | null;
  auditTrailId: number;
  foodMenuName: string;
  imageUrl: string;
}

interface ItemApproval {
  data: FoodMenuItemApproval[];
  loading: boolean;
  error: string | null;
}

interface ApiResponse {
  data: FoodMenuItemApproval[];
}

export const fetchFoodMenuItemApproval = createAsyncThunk<
  FoodMenuItemApproval[],
  void,
  { rejectValue: string }
>('fetchFoodMenuItemApproval/Approval', async (_, { rejectWithValue }) => {
  try {
    const response = await apiService.get<ApiResponse>(
      '/get_all_food_menu_item_approval',
      PORT,
      MASTERURL,
    );
    return response.data;
  } catch (error) {
    return rejectWithValue('Failed to fetch food approvals');
  }
});

export const createFoodMenuItemApproval: any = createAsyncThunk(
  'FoodMenuItemApproval/createFoodMenuItemApproval',
  async (params: any, thunkAPI) => {
    console.log(params);
    try {
      const response = await apiService.post(
        'create_food_menu_item_approval',
        params,
        PORT,
        MASTERURL,
      );
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const updateFoodMenuItemApproval = createAsyncThunk<
  FoodMenuItemApproval[],
  { payload: any },
  { rejectValue: string }
>('updateFoodMenuItemApproval', async ({ payload }, { rejectWithValue }) => {
  try {
    const response = await apiService.put<ApiResponse>(
      '/update_food_menu_item_approval',
      payload,
      PORT,
      MASTERURL,
    );
    return response.data;
  } catch (error) {
    return rejectWithValue('Failed to update food approval');
  }
});

const initialState: ItemApproval = {
  data: [],
  loading: false,
  error: null,
};

const foodApprovelRqSlice = createSlice({
  name: 'FoodApproval',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFoodMenuItemApproval.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchFoodMenuItemApproval.fulfilled,
        (state, action: PayloadAction<FoodMenuItemApproval[]>) => {
          state.loading = false;
          state.data = action.payload;
        },
      )
      .addCase(fetchFoodMenuItemApproval.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Unknown error';
      })

      .addCase(updateFoodMenuItemApproval.fulfilled, (state) => {
        state.error = null;
      })
      .addCase(updateFoodMenuItemApproval.rejected, (state, action) => {
        state.error = action.payload ?? 'Update failed';
      });
  },
});

export default foodApprovelRqSlice.reducer;
